// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"layout_logoContainer__u7PiU","logo":"layout_logo__Ido20"};